import { render, staticRenderFns } from "./FDataTable.vue?vue&type=template&id=234c3fae&scoped=true&"
import script from "./FDataTable.vue?vue&type=script&lang=ts&"
export * from "./FDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./FDataTable.vue?vue&type=style&index=0&id=234c3fae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c3fae",
  null
  
)

export default component.exports